import { render, staticRenderFns } from "./developing.vue?vue&type=template&id=38cce5eb&scoped=true"
import script from "./developing.vue?vue&type=script&lang=js"
export * from "./developing.vue?vue&type=script&lang=js"
import style0 from "./developing.vue?vue&type=style&index=0&id=38cce5eb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38cce5eb",
  null
  
)

export default component.exports